import { Component, OnInit, ViewChild } from '@angular/core';
import { PedidoLista } from '../models/pedido-lista';
import { MatPaginator, PageEvent, MatDialog } from '@angular/material';
import { PedidoService } from '../services/pedido.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import swal from 'sweetalert2';
import {
  StatusDoPedido,
  PerfilDoUsuario,
  OrigemFiltroPedido,
} from '../models/enum';
import { FiltroPedido } from '../models/filtro-pedido';
import { FiltroPedidoComponent } from '../pedido/filtro-pedido/filtro-pedido.component';
import { GlobalService } from '../services/global.service';
import { Pedido } from '../models/pedido';
import { Cliente } from '../models/cliente';
import { VendaEntrega } from '../models/venda-entrega';
import { PremissasService } from '../services/premissas.service';
import { UsuarioIntegrador } from '../models/usuario-integrador';
import { UsuarioLogado } from '../models/usuario-logado';
import { GerenciarClassificacaoPersonalizadaModalComponent } from '../modals/gerenciar-classificacao-personalizada-modal/gerenciar-classificacao-personalizada-modal.component';
import { FiltroClassificacaoPedidosComponent } from '../modals/filtro-classificacao-pedidos/filtro-classificacao-pedidos.component';
import { FiltroPedidoClassificacao } from '../models/filtro-pedido-classificacao';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-classificacao-pedidos',
  templateUrl: './classificacao-pedidos.component.html',
  styleUrls: ['./classificacao-pedidos.component.scss']
})
export class ClassificacaoPedidosComponent implements OnInit {
  pKitProntoDesconto = false;
  pedidosFiltrados: PedidoLista[] = [];
  pedidosSelecionados: PedidoLista[] = [];
  carregando = true;
  campoOrdenacao = 'idvenda';
  ordenarDesc = true;
  editavel = true;

  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [10,30,50];
  itensPorPagina = 10;
  clienteFaturamento: Cliente;
  calcularFrete = false;
  calcularDesconto = false;
  bloqClonar = false;
  fidelidadeGoSolar = false;

  usuariosDoIntegrador: UsuarioIntegrador[] = [];
  idUsuarioIntegrador;

  texto = 'Pedido';

  StatusDoPedido = StatusDoPedido;
  PerfilDoUsuario = PerfilDoUsuario;

  confirmar = false;

  perfil: PerfilDoUsuario;

  filtroPedido: FiltroPedido = {
    dtFim: undefined,
    dtInicio: undefined,
    funcionario: undefined,
    idCupom: '',
    nomeCliente: '',
    status: undefined,
    etapas: [],
    integrador: undefined,
    orcStatus: undefined,
    referencia: undefined,
    idFornecedor: undefined,
    codErp: '',
    pesquisaPorTimes: false
  };

  filtroExterno: any;

  integrador = false;
  tipo = 0;
  pedido: Pedido;
  itens: any[] = [];
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  verCustos = undefined;
  administrador;

  podeConfirmarPedido = false;
  podeVerTodosPedidos = false;

  respostas = [];

  modulosAtivos: Number[] = [];

  usuario: UsuarioLogado;
  filtroClassificacao = null;
  tabelas = [];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  buscouPedidos = false;
  selecionarTodos: boolean = false;
  aplicarParaSelecao: boolean = false;

  constructor(
    private pedidoService: PedidoService,
    public utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    public premissasService: PremissasService,
    private router: Router,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private paginatorService: PaginatorService
  ) {
    if (
      this.router.getCurrentNavigation().extras.state &&
      this.router.getCurrentNavigation().extras.state.filtro
    ) {
      this.filtroExterno =
        this.router.getCurrentNavigation().extras.state.filtro;
    }
   }

  async ngOnInit() {
    await this.buscarModulosAtivos();

    this.usuario = await this.globalService.consultaUsuario();
    this.integrador = await this.globalService.integrador();
    this.administrador = await this.globalService.administrador();

    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.verCustos = this.usuario.verCustos;
    this.perfil = await this.globalService.perfil();


    this.podeConfirmarPedido = this.usuario.podeConfirmarPedido;

    if (this.integrador) {
      this.podeVerTodosPedidos = this.usuario.verTodosPedidos;
      this.idUsuarioIntegrador = this.usuario.idUsuarioIntegrador;
    }

    this.route.data.subscribe((data: Data) => {
      this.tipo = data['tipo'];
      this.texto = this.tipo === 0 ? 'Orçamento' : 'Pedido';
    });

    if (localStorage.getItem('filtroPedido') !== null) {
      this.filtroPedido = JSON.parse(localStorage.getItem('filtroPedido'));
      if (this.filtroPedido.funcionario === null || this.filtroPedido.funcionario === undefined) {
        if (this.administrador) {
          this.filtroPedido.funcionario = 0;
        } else if (!this.integrador) {
          this.filtroPedido.funcionario = -1;
        }
      }
    } else {
      if (this.perfil === PerfilDoUsuario.Vendedor) {
        this.filtroPedido.funcionario = -1; // this.globalService.consultaUsuario().id;
      }
    }

    if (this.filtroExterno) {
      this.filtroPedido.status = StatusDoPedido.Ativo;
      this.filtroPedido.dtInicio = this.filtroExterno.dataInicio;
      this.filtroPedido.dtFim = this.filtroExterno.dataFim;
      this.filtroPedido.integrador = this.filtroExterno.integrador;
      this.filtroPedido.funcionario = this.filtroExterno.vendedor;
      if (this.filtroExterno.etapa) {
        this.filtroPedido.etapas = [this.filtroExterno.etapa];
      } else {
        this.filtroPedido.etapas = [];
      }
    }

    this.buscarPedidos();
  }

  classificacaoPersonalizada(pedido) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(GerenciarClassificacaoPersonalizadaModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        editavel: true,
        tabelas: pedido.camposPersonalizadosMontar,
        mostraSalvar: true,
        idCupom: pedido.idCupom,
        telaClassificacao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.buscarPedidos();
       }
    });
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some(p => p === modulo);
  }

  async buscarModulosAtivos() {

    try {
      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarPedidos();
    this.paginator.firstPage();
  }

  buscarPedidos() {
    this.buscouPedidos = false;

    localStorage.setItem('filtroPedido', JSON.stringify(this.filtroPedido));

    let etapas = undefined;
    if (this.tipo === 0) {
      etapas = '-1';
    } else if (
      this.filtroPedido.etapas &&
      this.filtroPedido.etapas.length > 0
    ) {
      etapas = this.filtroPedido.etapas.join(',');
    }

    this.pedidoService
      .consultarComPaginacao(
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.campoOrdenacao,
        this.ordenarDesc ? 'desc' : 'asc',
        this.filtroPedido.dtInicio &&
          typeof this.filtroPedido.dtInicio !== 'string'
          ? this.filtroPedido.dtInicio.toISOString()
          : this.filtroPedido.dtInicio,
        this.filtroPedido.dtFim && typeof this.filtroPedido.dtFim !== 'string'
          ? this.filtroPedido.dtFim.toISOString()
          : this.filtroPedido.dtFim,
        this.filtroPedido.nomeCliente,
        this.filtroPedido.idCupom,
        this.filtroPedido.status,
        this.filtroPedido.funcionario === 0
          ? undefined
          : this.filtroPedido.funcionario === -1
            ? this.usuario.id
            : this.filtroPedido.funcionario,
        etapas,
        false,
        false,
        this.filtroPedido.integrador ? this.filtroPedido.integrador : null,
        this.filtroPedido.orcStatus, null, null, null, null, null, null, null, null, null,
        this.integrador && this.podeVerTodosPedidos ? this.filtroPedido.idUsuarioIntegrador : this.idUsuarioIntegrador,
        this.filtroPedido.referencia, null, this.filtroPedido.codErp, this.filtroClassificacao, null, false, false, true, true
      )
      .subscribe(
        (dados) => {
          this.pedidosFiltrados = dados.itens;

          // this.listaDeItensPorPagina =
          //   this.utilitarioService.calculaItensPorPagina(dados.total);

          // if (
          //   this.itensPorPagina >
          //   this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]
          // ) {
          //   this.itensPorPagina = 10;
          // }

          this.paginacao.total = dados.total;

          this.buscouPedidos = true;
        },
        (erro) => {
          this.buscouPedidos = true;
          this.notificacaoService.erro(erro);
        }
      );
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPedidos();
  }

  pesquisarPedido() {
    const filtroTemp = Object.assign({}, this.filtroPedido);

    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(FiltroPedidoComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: { filtro: filtroTemp, tipo: this.tipo, origem: OrigemFiltroPedido.ClassificacaoPedidos },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result: FiltroPedido) => {
      if (result) {
        this.filtroPedido = result;
        this.buscarPedidos();
      }
    });
  }

  salvarPedido() {
    this.carregandoService.mostra('salvaPedido');

    this.pedidoService
      .salvar(
        this.pedido,
        this.itens,
        [],
        this.pedido.vendaDireta ? this.clienteFaturamento : null,
        false,
        this.tipo === 0,
        true,
        this.enderecoDeEntrega,
        this.respostas
      )
      .subscribe(
        (resp: any) => {
          this.notificacaoService.sucesso('Pedido salvo com sucesso!!!');
          this.router.navigate(['/pedidos']).then((p) => {
            this.carregandoService.esconde('salvaPedido');
          });
        },
        (erro) => {
          this.carregandoService.esconde('salvaPedido');
          this.notificacaoService.erro(erro);
        }
      );
  }

  restaurarFiltros() {
    this.filtroPedido = {
      dtFim: undefined,
      dtInicio: undefined,
      funcionario: this.administrador ? 0 : (!this.integrador ? -1 : undefined),
      idCupom: '',
      nomeCliente: '',
      status: undefined,
      etapas: [],
      integrador: undefined,
      orcStatus: undefined,
      idUsuarioIntegrador: undefined,
      referencia: undefined,
      idFornecedor: undefined,
      codErp: '',
      pesquisaPorTimes: false
    };
    this.tabelas = [];
    this.filtroClassificacao = null;
    this.paginacao.paginaAtual = 1;

    try {
      this.paginator.firstPage();
    } catch {}

    this.buscarPedidos();
  }

  //ação = false -> Filtro | ação = true -> Aplicar Classificação Seleção
  filtrarClassificacao(acao = false) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(FiltroClassificacaoPedidosComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        tabelas: this.tabelas,
        acao: acao,
        pedidosSelecionado: this.pedidosSelecionados
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.tabelas = result;

        let filters: FiltroPedidoClassificacao[] = [];

        result.forEach(t => {
          let filter: FiltroPedidoClassificacao = new FiltroPedidoClassificacao();

          if (t.itemSelecionado !== null || t.itensSelecionados !== null || t.textoSelecionado !== null) {
            filter.idTabela = t.id;
            filter.tipo = t.tipo;

            switch (t.tipo) {
              case 0:
                filter.itemSelecionado = t.itemSelecionado;
                break;
              case 1:
                filter.itensSelecionados = t.itensSelecionados;
                break;
              case 2:
                filter.textoSelecionado = t.textoSelecionado;
                break;
            }

            filters.push(filter);
          }
        });

        this.filtroClassificacao = filters.length > 0 ? JSON.stringify(filters) : null;
        this.paginacao.paginaAtual = 1;

        this.buscarPedidos();
       } else if (!result && acao) {
        this.buscarPedidos();
       }
    });
  }

  selecionarPedidos(pedido: PedidoLista) {
    const indicePedidoSelecionado = this.pedidosSelecionados.findIndex(p => p.idCupom === pedido.idCupom);

    if (pedido.pedidoSelecionado) {
      if (indicePedidoSelecionado === -1) {
        this.pedidosSelecionados.push(pedido);
      }
    } else {
      if (indicePedidoSelecionado !== -1) {
        this.pedidosSelecionados.splice(indicePedidoSelecionado, 1);
        if (!this.pedidosSelecionados.some(p => p.pedidoSelecionado = true))
          this.selecionarTodos = false;
      }
    }

    this.aplicarParaSelecao = this.pedidosSelecionados.some(p => p.pedidoSelecionado = true);
  }

  selecionarTodosPedidos() {
    if (this.selecionarTodos) {
      this.pedidosFiltrados.forEach(p => {p.pedidoSelecionado = true; this.pedidosSelecionados.push(p)});
    }
    else {
      this.pedidosFiltrados.forEach(p => p.pedidoSelecionado = false);
      this.aplicarParaSelecao = false;
      this.pedidosSelecionados = [];
    }
  }

}


